import React, { useState, useEffect } from 'react';
import { Grid } from '@material-ui/core';
import DmtIcon from 'Components/DashboardIcon/DmtIcon';
import { LOGOUT } from 'ConstComponents';
import { Container, Paper, IconButton } from '@material-ui/core';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import { MultiActivePPI as PPI_MULTI_ACTIVE } from 'Components/Api/PPISettingAPI';
import HOCLoader from 'Components/Loader/HOCLoader';
import { useHistory } from 'react-router';
import LeadGenerationIcon from 'Components/DashboardIcon/LeadGenerationIcon';
import CreditCardIcon from 'Components/DashboardIcon/CreditCardIcon';
import AccountIcon from 'Components/DashboardIcon/Account';
export const OtherBankBeneficiary = () => {
    const history = useHistory();

    const [loadingOpen, setLoadingOpen] = useState(false);
    const [isError, setIsError] = useState(false);
    const [responseMessage, setResponseMessage] = useState('');
    const [severity, setSeverity] = useState('success');
    const classes = commonStyle();
    const CustomContainer = HOCLoader(Container);

    const handleAddBeneficiaryClick = () => {
        history.push('/AddBeneficiary');
    };

    const handleViewBeneficiaryClick = () => {
        history.push('/ViewBeneficiary');
    };

    return (
        <CustomContainer
            isLoading={loadingOpen}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        >
            <Paper className={classes.PaperStyle}>
                <Grid container>
                    <Grid
                        item
                        xs={6}
                        sm={6}
                        md={4}
                        lg={2}
                        xl={2}
                        className="text-center"
                    >
                        <IconButton
                            color="primary"
                            className="dashmenu"
                            component="div"
                            onClick={handleAddBeneficiaryClick}
                        >
                            <AccountIcon
                                name={'Add Beneficiary'}
                                width={64}
                                height={64}
                                fill="red"
                            />
                        </IconButton>
                    </Grid>

                    <Grid
                        item
                        xs={6}
                        sm={6}
                        md={4}
                        lg={2}
                        xl={2}
                        className="text-center"
                    >
                        <IconButton
                            color="primary"
                            className="dashmenu"
                            component="div"
                            onClick={handleViewBeneficiaryClick}
                        >
                            <LeadGenerationIcon
                                name={'View Beneficiary'}
                                width={64}
                                height={64}
                                fill="red"
                            />
                        </IconButton>
                    </Grid>
                </Grid>
            </Paper>
        </CustomContainer>
    );
};
